import React, { Component } from "react";
import { Form, Layout, Input, Row, Col, Modal, Table, Button, Icon, Menu, Dropdown } from "antd";
import "./index.scss";
import moment from "moment";
import RegisterModal from "./components/RegisterModal";
import { checkPermission } from "../../utils/helper";
import { Redirect } from "react-router-dom";

const { Content } = Layout;

class Attendance extends Component {
  initialState = {
    event: [],
    searchText: '',
    searchedColumn: '',
    attendanceData: [],
    selectedRow: {},
    selectedRowKeys: [],
    registrationFieldsData: [],
    fieldsData: [],
    showUploadModal: false,
    searchKey: [],
    pagination: {},
    tableData: [],
    searchText: '',
    searchedColumn: '',
    showRegistrationModal: false
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleCloseModal = () => {
    this.setState({
      showRegistrationModal: false,
    });
  }

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });

    this.props.onGetAttendance({
      results: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      event_id: this.props.event.id,
      ...filters,
    });
  };

  componentDidMount() {
    const onGetParam = {
      event_id: this.props.event.id,
      results: 10
    };
    this.props.onGetAttendance(onGetParam);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.attendanceData !== nextProps.attendanceData) {
      let tableData = [];
      nextProps.attendanceData.forEach(row => {
        let searchValue = `${row.registration.email} ${row.registration.source_type} ${row.registration.ticket.ticket_name} ${row.registration.qr_code} `;

        row.registration.values.forEach(value => {
          searchValue += ` ${value.field_value}`;
        });
        const newRow = {
          ...row,
          search: searchValue
        };
        tableData.push(newRow);
      });

      this.setState({
        attendanceData: tableData,
        tableData: tableData
      });
    }

    if (this.props.attendanceTotal !== nextProps.attendanceTotal) {
      const pagination = { ...this.state.pagination };
      pagination.total = nextProps.attendanceTotal;
      this.setState({
        pagination,
      });
    }
  }

  handleSearch = (searchTerm, searchKeys) => {
    const convertStringDotNotation = (desc, obj) => {
      var arr = desc.split(".");
      while (arr.length && (obj = obj[arr.shift()]));
      return obj;
    };
    const { attendanceData } = this.state;
    const newArrayObj = attendanceData;
    if (!searchTerm) {
      return this.setState({ tableData: newArrayObj });
    }
    let distributorArray = [];
    newArrayObj.forEach((rowItem, i) => {
      searchKeys.forEach((keys) => {
        let rowItemKeys = convertStringDotNotation(keys, { ...rowItem });
        let isFound =
          rowItemKeys &&
          rowItemKeys.toLowerCase().includes(searchTerm.toLowerCase());
        if (isFound) distributorArray.push(rowItem);
      });
    });
    const newArrayElement = distributorArray.filter(function (
      elem,
      index,
      self
    ) {
      return index === self.indexOf(elem);
    });
    this.setState({ tableData: newArrayElement });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearchApi(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearchApi(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
  });

  handleSearchApi = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  handleMenuClick = (e) => {
    const { selectedRowKeys } = this.state;
    const key = e.key;
    switch (key) {
      case "register":
        this.setState({
          showRegistrationModal: true
        });
        break;

      case "export":
        const onGetParam = {
          event_id: this.props.event.id,
          event_name: this.props.event.event_name
        };
        this.props.onExportAttendance(onGetParam);
        break;

      default:
        break;
    }
  }

  render() {
    const { tableData, attendanceData, pagination, showRegistrationModal } = this.state;
    const { isLoading, event } = this.props;
    const module = "attendance";

    if (!checkPermission(module, "view")) {
      return (<Redirect to="/403" />);
    }

    const columns = [
      {
        title: 'Email Address',
        dataIndex: 'email',
        key: 'email',
        render: (column, row) => {
          return (row.registration.email);
        },
        ...this.getColumnSearchProps('email'),
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        ...this.getColumnSearchProps('name'),
        render: (text, record) => (
          <span>{`${record.registration.first_name ?? ""} ${record.registration.last_name ?? ""} ${record.registration.name ?? ""}`}</span>
        )
      },
      {
        title: 'Ticket',
        dataIndex: 'ticket.ticket_name',
        key: 'ticket.ticket_name',
        align: 'center',
        // sorter: (a, b) => a.ticket.length - b.ticket.length,
        // sortDirections: ['descend', 'ascend'],
        render: (column, row) => {
          return (row.registration.ticket.ticket_name);
        },
      },
      {
        title: 'First Scan',
        dataIndex: 'created_at',
        key: 'created_at',
        align: 'center',
        render: (created_at) => {
          return (moment(created_at).format("hh:mm:s A"))
        },
        // sorter: (a, b) => a.ticket.length - b.ticket.length,
        // sortDirections: ['descend', 'ascend'],
      },
      // {
      //   title: 'Latest Scan',
      //   dataIndex: 'updated_at',
      //   key: 'updated_at',
      //   align: 'center',
      //   render: (updated_at) => {
      //     return (moment(updated_at).format("hh:mm:s A"))
      //   },
      //   sorter: (a, b) => a.ticket.length - b.ticket.length,
      //   sortDirections: ['descend', 'ascend'],
      // },
    ];

    return (
      <Layout className="registration-container" >
        <Content className="registration-content" style={{ padding: "20px 60px" }}>
          <Row type="flex" gutter={30}>
            <Col span={24}>
              <h2>Attendance {pagination.total ?? ''}</h2>
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={12} className="page-content-control-button-holder">
              {checkPermission(module, "manual-register") || checkPermission(module, "export-data") ? (
                <Dropdown loading={isLoading} overlay={
                  <Menu onClick={this.handleMenuClick}>
                    {/* {checkPermission(module, "manual-register") ? (<Menu.Item key="register">Register Manually</Menu.Item>) : ''} */}
                    {checkPermission(module, "export-data") ? (<Menu.Item key="export">Export Data</Menu.Item>) : ''}

                  </Menu>
                }>
                  <Button type="primary">
                    Actions <Icon type="down" />
                  </Button>
                </Dropdown>
              ) : ''}
            </Col>
            <Col span={12}>
            </Col>
          </Row >

          <Row type="flex" gutter={30}>
            <Col span={24}>
              <Table columns={columns} dataSource={tableData}
                rowKey={record => record.id}
                loading={isLoading}
                onChange={this.handleTableChange}
                pagination={pagination}
                expandedRowRender={attendance => (
                  <Row type="flex" gutter={30} key={"expanded-row-" + attendance.id}>
                    {attendance.registration.values.map(field => {
                      return (
                        <Col span={8} style={{ marginBottom: "10px" }} key={field.id}>
                          <span style={{ fontWeight: "bold" }}>{field.field.label}:</span>&nbsp;&nbsp;
                          <span>{field.field_value}</span>
                        </Col>
                      );
                    })}
                  </Row>
                )}
              />
            </Col>
          </Row>
        </Content >

        <RegisterModal showModal={showRegistrationModal} handleCloseModal={this.handleCloseModal} {...this.props} />
      </Layout >
    );
  }
}

const AttendanceForm = Form.create({ name: "attendance-form" })(Attendance);

export default AttendanceForm;
